import { useMemo } from "react";
import {
  WarrantyPackage,
  WarrantyPackageVoucher,
} from "shared/api/middleware-api-client";

export function useWarrantyOrderVoucherData({
  warrantyPackages,
  voucherWarranties,
}: {
  warrantyPackages: readonly WarrantyPackage[];
  voucherWarranties: readonly WarrantyPackageVoucher[] | undefined;
}) {
  const voucherWarrantyPackage = useMemo(() => {
    if (!voucherWarranties || voucherWarranties?.length <= 0) return undefined;
    return (
      warrantyPackages.find((pkg) =>
        voucherWarranties.some((vw) => vw.id === pkg.packageId),
      ) ?? undefined
    );
  }, [warrantyPackages, voucherWarranties]);

  return {
    voucherWarrantyPackage,
  };
}
